// extracted by mini-css-extract-plugin
module.exports = {"header":"header-3NGBn","logo":"logo-1FVuI","trigger":"trigger-3SCxV","center":"center-152Ch","right":"right-1Rp41","action":"action-2TTWX"};